import requestAction from '../../utils/requestAction'
import SchoolJabberUser, { SchoolJabberUserInput } from '../../models/SchoolJabberUser';

export const bulkUpsertUsers = (records: (SchoolJabberUser|SchoolJabberUserInput)[]) =>
  requestAction('SCHOOL_JABBER_USER_BULK_UPSERT')('school-jabber-users/bulk', 'POST', { records })
